import WalletSDK from "@coinbase/wallet-sdk";

const coinbaseWallet = new WalletSDK({ appName: "Demo Lands" });

const chainId = process.env.REACT_APP_ETH_CHAIN_ID.toString(16);
const _provider = coinbaseWallet.makeWeb3Provider(process.env.REACT_APP_ETH_RPC_URL, chainId);

const activate = async () => {
  if (window.ethereum?.isCoinbaseWallet) {
    await _provider.send("wallet_switchEthereumChain", [{ chainId: chainId }]);
  }

  await _provider.enable();

  return _provider;
};

const getAddress = async () => {
  if (!_provider) {
    throw new Error("Please install corresponding wallet extension");
  }

  const accounts = await _provider.request({ method: "eth_requestAccounts" });
  return accounts[0];
};

const disconnect = () => {
  coinbaseWallet.disconnect();
};

export { activate, getAddress, disconnect };
